/*
 * @Author: cc
 * @LastEditTime: 2025-09-05 09:09:51
 */
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { IconName } from "@fortawesome/fontawesome-common-types";
import { Breadcrumb, Button, Modal } from "antd";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { post } from "../../common/fetch";
import { useQuery } from "../../common/utils";
import { Icon, Menu } from "../../components/index";
import project_bg from "../../img/project_bg.png";
import store from "../../reducers";
import { TopicCourseDoubleCourse } from "./component/topicExamDouble/topicDoubleCourseList";
import "./topicInfo.scss";
export type IconType = {
  iconStr: IconName;
};
interface navListProps {
  title: string;
  sub: string;
  icon: any;
}
interface classInfoProps {
  // 课程名称
  projectName: string;
  // 学习时间范围
  topicTimeRange: string;
  // 课程总时长
  topicDurationText: string;
  // 学习进度
  projectProgress: string;
  // 专题介绍
  intro: string;
  // 是否已经阅读
  topicProgress: number;
  // 项目封面图
  topicPicture: string;
  // 考试类型
  examSystemType: number;
  // 专题考试名称
  topicExamName: string;
  topicId: number;
  projectId: number;
  topicName?: string; // 专题名称
}
interface projectInfo {
  // 是否显示课程时长
  showCourseDurationFlag: number;
  // 课程时长
  topicDuration: string;
  // 课程时长文本
  topicDurationText: string;
  // 是否显示观看时间
  showWatchTimeFlag: number;
  // 观看时间
  topicWatchTime: string;
  // 观看时间文本
  topicWatchTimeText: string;
  // 是否显示课程数量
  showCourseCountFlag: number;
  // 课程数量
  topicCourseCount: number;
  // 是否显示已学习课程数量
  showLearnedCourseCountFlag: number;
  // 已学习课程数量
  topicLearnedCourseCount: number;
  // 是否显示课程考试数量
  showCourseExamCountFlag: number;
  // 课程考试数量
  topicCourseExamCount: number;
  // 是否显示已完成课程考试数量
  showFinishCourseExamCountFlag: number;
  // 已完成课程考试数量
  topicFinishCourseExamCount: number;
  // 是否显示学习进度
  showLearnProgressFlag: number;
  // 学习进度
  topicProgress: string;
  // 评分数量
  userEvaluateCount: number;
  // 是否显示评分数量
  showEvaluateCountFlag: number;
  // 项目成绩展示设置 0:关闭; 1:开启
  projectScoreShowSet: number;
  // 项目最高成绩
  projectTopicMaxScoreText: string;
  // 项目答题记录 0:关闭; 1:开启
  projectAnswerRecordShowFlag: number;
  topicAnswerRecordShowFlag: number; // 项目答题记录 0:关闭; 1:开启
  userPaperScoreId: number; // 用户试卷ID
  topicScoreShowSet: number; // 项目成绩展示设置 0:关闭; 1:开启
}
// 项目成绩信息接口
interface ProjectScoreInfo {
  projectScoreShowSet: number; // 项目成绩展示设置 0:关闭; 1:开启
  projectId: number; // 项目ID
  projectName: string; // 项目名称
  courseSumScoreText: string; // 课程成绩汇总
  projectCourseExamCount: number; // 项目课程考试数量
}
interface ExamProps {
  // 是否有专题考试标志
  hasTopicExamFlag: number;
  // 是否有专题问卷调查标志
  hasTopicQuestionnaireFlag: number;
  // 专题考试状态
  topicExamStatus: number;
  // 专题问卷调查状态
  topicQuestionnaireStatus: number;
}
function HeaderIcon(props: IconType) {
  const { iconStr } = props;
  return <Icon icon={iconStr} size="1x" theme="gray" />;
}

let projectId: string;
const QuestionStatus = ["不可以调查问卷", "可以调查问卷", "完成调查问卷"];
const ExamStatus = new Map([
  ["0", "学习进度未达标"],
  ["1", "可以考试"],
  ["2", "通过考试"],
  ["7", "未完成调查问卷"],
  ["8", "未考试"],
]);
function TopicInfo(props: any) {
  const query = useQuery();
  projectId = query.get("projectId") as string;
  const {
    projectType: { type },
  } = props;
  const [projectScoreInfo, setProjectScoreInfo] =
    useState<ProjectScoreInfo | null>(null);
  const [navIndex, setNavIndex] = useState("1");
  const [projectInfo, setProjectInfo] = useState<projectInfo>(
    {} as projectInfo
  );
  const topicId = query.get("topicId") as string;
  const [navlist] = useState<navListProps[]>([
    { title: "专题介绍", sub: "1", icon: "bullhorn" },
    { title: "课程列表", sub: "2", icon: "list-ul" },
    { title: "专题考试", sub: "3", icon: "landmark" },
  ]);
  const [classInfo, setClassInfo] = useState<classInfoProps>(
    {} as classInfoProps
  );
  const [questionExamInfo, setQuestionExamInfo] = useState<ExamProps>(
    {} as ExamProps
  );
  const getProjectInfo = () => {
    const url = `/shop/front/project/${projectId}/topic/${topicId}/info`;
    post(url, {}, true).then((res) => {
      const { data } = res;
      console.log("data", data);
      data.topicProgress = Number(parseFloat(data.topicProgress));
      const {
        hasTopicExamFlag,
        hasTopicQuestionnaireFlag,
        projectPageSetInfo,
        topicExamStatus,
        topicQuestionnaireStatus,
      } = data;
      setProjectInfo(data);
      setQuestionExamInfo({
        hasTopicExamFlag,
        hasTopicQuestionnaireFlag,
        topicExamStatus,
        topicQuestionnaireStatus,
      });
      setClassInfo(data);
      store.dispatch({
        type: "CHANGE_PROJECTINFO",
        payLoad: {
          ...projectPageSetInfo,
        },
      });
      sessionStorage.setItem(
        "projectPageSetInfo",
        JSON.stringify(projectPageSetInfo)
      );
    });
  };
  const getTopicQuestionnaireUrl = () => {
    const url = `/shop/questionnaire/getProjectTopicStarQuestionnaireUrl`;
    post(url, { projectId, topicId }, true).then((res) => {
      const { questionnaireUrl } = res.data;
      window.location.href = questionnaireUrl;
    });
  };
  // 项目考试
  const checkExamFlag = async (it: classInfoProps) => {
    // 获取考试剩余次数
    const { topicCanExamNum, topicExamLimitFlag, topicExamLimitNum } =
      await checkProjectExam();
    if (topicExamLimitFlag === 1) {
      Modal.confirm({
        title: "提示",
        icon: <ExclamationCircleOutlined />,
        content: (
          <div style={{ fontSize: "16px" }}>
            <p>
              本场共{" "}
              <span style={{ fontSize: "24px", color: "red" }}>
                {topicExamLimitNum}
              </span>{" "}
              次机会
            </p>
            <p>
              当前剩余{" "}
              <span style={{ fontSize: "24px", color: "red" }}>
                {topicCanExamNum}
              </span>{" "}
              次
            </p>
          </div>
        ),
        okText: "确认",
        cancelText: "取消",
        onOk() {
          getProjectExamUrl(it, topicCanExamNum, topicExamLimitFlag);
        },
      });
    } else {
      getProjectExamUrl(it, topicCanExamNum, topicExamLimitFlag);
    }
  };
  const checkProjectExam = (): Promise<{
    topicCanExamNum: number;
    topicExamLimitFlag: number;
    topicExamLimitNum: number;
  }> => {
    return new Promise((resolve, reject) => {
      post(
        `/shop/exam/checkProjectTopicExam`,
        {
          projectId,
          topicId,
        },
        true
      ).then((res) => {
        const { topicCanExamNum, topicExamLimitFlag, topicExamLimitNum } =
          res.data;
        resolve({
          topicCanExamNum,
          topicExamLimitFlag,
          topicExamLimitNum,
        });
      });
    });
  };
  const getProjectExamUrl = (
    it: classInfoProps,
    topicCanExamNum: number,
    topicExamLimitFlag: number
  ) => {
    const { examSystemType, topicId, projectId } = it;
    // 如果剩余次数是0次，则不跳转，并且不是无限次
    if (topicCanExamNum === 0 && topicExamLimitFlag === 1) {
      return;
    }
    if (examSystemType === 2) {
      const { REACT_APP_BASE_URL, REACT_APP_EXAM_URL } = process.env;
      window.location.href = `${REACT_APP_BASE_URL}${REACT_APP_EXAM_URL}/exam-list/examList?fromType=topicProjectExam&projectId=${projectId}&topicId=${topicId}`;
    } else {
      post(
        `/shop/exam/getProjectTopicExamUrl`,
        {
          projectId,
          topicId,
        },
        true
      ).then((res) => {
        const { topicExamUrl } = res.data;
        window.location.href = topicExamUrl;
      });
    }
  };
  // 获取项目成绩信息
  const getProjectScoreInfo = () => {
    const url = `/shop/front/user/project/score/info`;
    post(url, { projectId }, true)
      .then((res) => {
        if (res.code === 0) {
          setProjectScoreInfo(res.data);
        }
      })
      .catch((error) => {
        console.error("获取项目成绩信息失败:", error);
      });
  };
  /**
   *
   * @param item 项目考试记录
   */
  const examPaperRecord = (userPaperScoreId: any) => {
    const { REACT_APP_BASE_URL, REACT_APP_EXAM_URL } = process.env;
    const examResultUrl = `${REACT_APP_BASE_URL}${REACT_APP_EXAM_URL}/record-list?userPaperScoreId=${userPaperScoreId}&type=projectExam`;
    window.open(examResultUrl);
  };
  useEffect(() => {
    getProjectInfo();
    getProjectScoreInfo();
  }, [type]); // eslint-disable-line react-hooks/exhaustive-deps
  // 根据项目区分隐藏项目时长和项目总时长
  // const xjProjectFlag = useMemo(() => {
  //   const projectArr = ["487", "488", "489"];
  //   return projectArr.includes(projectId);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [projectId]);
  const {
    hasTopicExamFlag,
    hasTopicQuestionnaireFlag,
    topicExamStatus,
    topicQuestionnaireStatus,
  } = questionExamInfo;
  return (
    <div className="projectInfo_box">
      <div className="project_header">
        <img className="header_img" src={project_bg} alt="" />
        <div className="project_title">
          <Breadcrumb
            separator="/"
            style={{ fontSize: "20px", marginBottom: "30px" }}
          >
            <Breadcrumb.Item
              href={`/#/projectInfo?projectId=${projectId}&projectType=1`}
            >
              培训主页
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>专题主页</span>
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="project_detail_box">
            <img
              src={classInfo?.topicPicture}
              alt=""
              style={{ width: "469px", height: "300px" }}
            />
            <div style={{ paddingLeft: "20px" }}>
              <h2>{classInfo?.topicName}</h2>
              <div className="time">
                {classInfo?.topicTimeRange && (
                  <p>开放时间：{classInfo?.topicTimeRange}</p>
                )}

                {/* {!xjProjectFlag && classInfo?.topicDurationText!=="00:00:00" && (
                  <p>
                      专题时长：{classInfo?.topicDurationText}
                  </p>
                )}
                {classInfo?.topicProgress > 0 && <p>
                  <HeaderIcon iconStr={"calendar-week"} />
                    学习进度：{classInfo?.topicProgress}%
                </p>} */}
                <div>
                  {projectInfo.showCourseDurationFlag === 1 &&
                    projectInfo?.topicDurationText !== "00:00:00" && (
                      <p style={{ width: "50%" }}>
                        课程时长：{projectInfo?.topicDurationText}
                      </p>
                    )}
                  {projectInfo.showWatchTimeFlag === 1 && (
                    <p>已学时长：{projectInfo?.topicWatchTimeText}</p>
                  )}
                </div>
                <div>
                  {/* 课程项目总时长 */}

                  {projectInfo.showCourseCountFlag === 1 && (
                    <p style={{ width: "50%" }}>
                      课程数量：
                      {projectInfo.topicCourseCount
                        ? projectInfo.topicCourseCount
                        : 0}
                    </p>
                  )}
                  {projectInfo.showLearnedCourseCountFlag === 1 && (
                    <p>
                      课程学完数量：
                      {projectInfo.topicLearnedCourseCount
                        ? projectInfo.topicLearnedCourseCount
                        : 0}
                    </p>
                  )}
                </div>
                <div>
                  {projectInfo.showEvaluateCountFlag === 1 && (
                    <p style={{ width: "45%" }}>
                      评分数量：
                      {projectInfo.userEvaluateCount}
                    </p>
                  )}
                </div>
                <div>
                  {projectInfo.showCourseExamCountFlag === 1 && (
                    <p style={{ width: "50%" }}>
                      练习数量：
                      {projectInfo.topicCourseExamCount
                        ? projectInfo.topicCourseExamCount
                        : 0}
                    </p>
                  )}
                  {projectInfo.showFinishCourseExamCountFlag === 1 && (
                    <p>
                      练习通过数量：
                      {projectInfo.topicFinishCourseExamCount
                        ? projectInfo.topicFinishCourseExamCount
                        : 0}
                    </p>
                  )}
                </div>
                <div>
                  {projectInfo.showLearnProgressFlag === 1 && (
                    <p style={{ width: "50%" }}>
                      学习进度：
                      {projectInfo.topicProgress}%
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="project_list">
            <div>
              <Menu
                index={navIndex}
                defaultOpenSubMenus={[]}
                mode="horizontal"
                onSelect={(index) => {
                  setNavIndex(index);
                }}
              >
                {navlist.map((it: navListProps, index: number) => (
                  <Menu.Item key={index}>
                    <Icon
                      icon={it.icon}
                      size="1x"
                      theme="dark"
                      style={{ marginRight: "8px" }}
                    />
                    <span>{it.title}</span>
                  </Menu.Item>
                ))}
              </Menu>
              <div className="video_box">
                {projectScoreInfo?.courseSumScoreText && (
                  <h4>
                    练习最高分合计：{projectScoreInfo?.courseSumScoreText}
                  </h4>
                )}
                {navIndex === "0" && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: classInfo?.intro as string,
                    }}
                  ></div>
                )}
                {/* 课程 */}
                {navIndex === "1" && (
                  <>
                    <TopicCourseDoubleCourse
                      projectId={projectId}
                      topicId={topicId}
                      projectInfo={projectInfo}
                    />
                  </>
                )}
                {navIndex === "2" && (
                  <div className="examInfo_box">
                    {hasTopicQuestionnaireFlag === 1 && (
                      <div>
                        <p>项目问卷</p>
                        <p
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <p>
                            状态：
                            {QuestionStatus[topicQuestionnaireStatus]}
                          </p>
                          <p>
                            <Button
                              type={
                                topicQuestionnaireStatus === 0 ||
                                topicQuestionnaireStatus === 2
                                  ? "ghost"
                                  : "primary"
                              }
                              disabled={
                                topicQuestionnaireStatus === 0 ||
                                topicQuestionnaireStatus === 2
                              }
                              onClick={getTopicQuestionnaireUrl}
                            >
                              进入问卷
                            </Button>
                          </p>
                        </p>
                      </div>
                    )}
                    {hasTopicExamFlag === 1 && (
                      <div>
                        <p>{classInfo?.topicExamName}</p>
                        <p
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <p>
                            <span>
                              状态：{ExamStatus.get(topicExamStatus.toString())}
                            </span>
                            &emsp;
                            {projectInfo?.topicScoreShowSet > 1 && (
                              <span>
                                最高成绩：
                                {projectInfo?.projectTopicMaxScoreText}
                              </span>
                            )}
                          </p>
                          <p>
                            {projectInfo?.topicAnswerRecordShowFlag === 1 && (
                              <Button
                                type="primary"
                                onClick={() => {
                                  examPaperRecord(projectInfo.userPaperScoreId);
                                }}
                              >
                                最新答题记录
                              </Button>
                            )}
                            &emsp;
                            <Button
                              type="primary"
                              onClick={() => {
                                checkExamFlag(classInfo);
                              }}
                              disabled={
                                topicExamStatus === 0 ||
                                topicExamStatus === 10 ||
                                topicExamStatus === 6 ||
                                topicExamStatus === 7
                              }
                            >
                              进入考试
                            </Button>
                          </p>
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const getProjectType = (state: {
  projectType: { type: number; activityId?: string };
}) => {
  return {
    projectType: state.projectType,
  };
};
export default connect(getProjectType)(TopicInfo);
